import React, { Component, PropTypes } from 'react';
import Reflux from 'reflux';
import { AppBar, Paper, Styles, IconButton, TextField } from 'material-ui';
import EventManager from 'services/EventManager';
import { AppActions, AuthActions } from 'actions';
import { AuthStore } from 'stores';
import { mixin, RefluxMixin } from 'Util';
import * as SvgIcons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import { StoreOverviewActions } from 'actions';
import { history } from 'helpers';
// import ReactGestures from 'react-gestures';

let { ActionSearch } = SvgIcons;

const styles = {
  iconButton: {
    flex: '0 1',
    border: 18,
    padding: 20,
    width: 64,
    height: 64
  },
  image: {
    maxHeight: 56,
    verticalAlign: 'middle'
  },
  root: {}
};

const css = oxygenCss({
  root: {
    display: 'flex',
    backgroundColor: '#FFF',
    color: '#000',
    maxWidth: '100%',
    minHeight: 64,
    alignItems: 'stretch',
  },
  header: {
    fontSize: '24px',
    margin: 0,
    fontWeight: 100,
    color: '#FFFFFF',
    flexGrow: 1,
    flexShrink: 0,
    textAlign: 'center',
    padding: 4,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center'
  },
  left: {
    display: 'flex',
    width: '25%',
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: 'flex-start'
  },
  right: {
    display: 'flex',
    width: '25%',
    flexGrow: 0,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  link: {
    cursor: 'pointer',
    marginLeft: 10,
    marginRight: 10,
    '>SPAN': {
      '@phone': {
        display: 'none !important',
        marginLeft: 0,
        marginRight: 0
      }
    },
    linkName: {
      lineHeight: '64px'
    },
    '>SVG': {
      display: 'none !important',
      '@phone': {
        display: 'inline-block !important',
        marginRight: 0,
        margin: '-11px',
        paddingLeft: '10px'
      }
    },
    '@phone': {
      fontSize: 10,
      display: 'inline-block',
      cursor: 'pointer',
      position: 'relative',
      padding: '0 15px 0 0',
      flex: '0 1'
    }
  }
});

export default class StoreBar extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  static propTypes = {
    title: PropTypes.string,
    store: PropTypes.string,
    mode: PropTypes.string,
    canIEdit: PropTypes.bool
  };

  listenToStores() {
    this.listenToStore(AuthStore);
  }

  toggle = e => {
    AppActions.toggleAppBar();
    e.preventDefault();
  };

  logout = () => {
    AuthActions.logout();
  };

  editMode = () => {
    StoreOverviewActions.editMode();
  };

  listMode = () => {
    StoreOverviewActions.listMode();
  };

  gotoStore = () => {
    const { store } = this.props;
    history.push(`/store/${store}`);
  };

  gotoDashboard = () => {
    history.push(`/`);
  };

  render() {
    const { mode, store, children, logo, canIEdit, ...other } = this.props;
    const { loggedIn } = this.state;
    const { getIntlMessage } = this.context;
    return (
      <div className={css.root} {...other}>
        <div className={css.left}>
          {loggedIn && (
            <IconButton style={styles.iconButton} onTouchTap={this.toggle}>
              <SvgIcons.NavigationMenu
                color={'rgba(0, 0, 0, 0.9)'}
                hoverColor={'rgba(0, 0, 0, 0.5)'}
              />
            </IconButton>
          )}
          {loggedIn &&
            canIEdit &&
            mode === 'list' && (
              <IconButton style={styles.iconButton} onTouchTap={this.editMode}>
                <SvgIcons.EditorModeEdit
                  color={'rgba(0, 0, 0, 0.9)'}
                  hoverColor={'rgba(0, 0, 0, 0.5)'}
                />
              </IconButton>
            )}
          {store && (
            <div className={css.link} onTouchTap={this.gotoStore}>
              <SvgIcons.ActionStore
                color={'rgba(0, 0, 0, 0.9)'}
                hoverColor={'rgba(0, 0, 0, 0.5)'}
              />
              <span className={css.linkName}>{getIntlMessage('store.goto')}</span>
            </div>
          )}
        </div>
        <div
          className={css.header}
          onTouchTap={this.gotoStore}
          style={{ backgroundImage: `url(${logo})` }}
        />
        <div className={css.right}>
          {loggedIn ? (
            <IconButton style={styles.iconButton} onTouchTap={this.logout}>
              <SvgIcons.ActionExitToApp
                color={'rgba(0, 0, 0, 0.9)'}
                hoverColor={'rgba(0, 0, 0, 0.5)'}
              />
            </IconButton>
          ) : (
            <div className={css.link} onTouchTap={this.gotoDashboard}>
              <SvgIcons.AvPlayArrow
                color={'rgba(0, 0, 0, 0.9)'}
                hoverColor={'rgba(0, 0, 0, 0.5)'}
              />
              <span>{getIntlMessage('login.toDashboard')}</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/StoreBar.js